module.exports = __webpack_public_path__ + "static/media/awfxex32_120.f2177903.ico";